"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JotForm1Schema = void 0;
exports.JotForm1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/jotform-forms/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "JotForm1",
    "description": "Add a form from JotForm",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:jotform-forms:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "jotFormId": {
                    "type": "string",
                    "description": "JotForm ID (e.g. 80421851676358)",
                    "pattern": "^[0-9]+$"
                }
            },
            "required": [
                "jotFormId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9qb3Rmb3JtLWZvcm1zLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsY0FBYyxHQUFHO0lBQzVCLEtBQUssRUFBRSxrRkFBa0Y7SUFDekYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsVUFBVTtJQUNuQixhQUFhLEVBQUUseUJBQXlCO0lBQ3hDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLDBDQUEwQzthQUMzQztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osV0FBVyxFQUFFO29CQUNYLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsa0NBQWtDO29CQUNqRCxTQUFTLEVBQUUsVUFBVTtpQkFDdEI7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixXQUFXO2FBQ1o7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==